import { useAppType, useUserDetailsQuery } from '@repo/lib';
import { AppType, MaintenanceType } from '@repo/types';
import {
  AppSidebar,
  AppSidebarInset,
  SidebarProvider,
  Spinner,
  Toaster,
} from '@ui/components';
import { MaintenanceProvider, VersionProvider } from '@ui/providers';

export const DashboardLayout = () => {
  const { data: user, isPending } = useUserDetailsQuery();
  const appType = useAppType();

  if (isPending || !user) {
    return (
      <div className="absolute inset-0">
        <Spinner className="size-14 text-primary" />
      </div>
    );
  }

  const content = (
    <VersionProvider>
      <SidebarProvider defaultOpen={true}>
        <AppSidebar />
        <AppSidebarInset />
        <Toaster />
      </SidebarProvider>
    </VersionProvider>
  );

  return appType === AppType.PORTAL ? (
    <MaintenanceProvider type={MaintenanceType.PORTAL}>
      {content}
    </MaintenanceProvider>
  ) : (
    content
  );
};
